(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-wave"] && !Shopify.designMode) return;
  try {
    
  // Verschmelzungs-Überlappung an der TATSÄCHLICHEN Hero-Höhe festmachen.
  // (CSS kann margin nicht als % der eigenen Höhe rechnen; auf Mobil wird der
  // Hero durch umbrechenden Text oft höher als min-height, sodass der mit der
  // echten Höhe skalierende Wellenschnitt sonst tiefer als die Überlappung ist.)
  (function () {
    function apply() {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      document.querySelectorAll('.hero-wave--merge-next').forEach(function (h) {
        var cut = parseFloat(mobile ? h.dataset.mergeCutMobile : h.dataset.mergeCut) || 0;
        var height = h.getBoundingClientRect().height;
        if (cut > 0 && height > 0) {
          h.style.marginBottom = -(cut * height) + 'px';
        }
      });
    }
    function ready(fn) {
      if (document.readyState !== 'loading') { fn(); }
      else { document.addEventListener('DOMContentLoaded', fn); }
    }

    // Overlay erst einblenden, wenn das Hero-Bild geladen ist → kein grauer
    // Flash (Overlay über noch leerer Fläche), während das große Bild lädt.
    function markMedia() {
      document.querySelectorAll('.hero-wave__media-grid').forEach(function (grid) {
        if (grid.classList.contains('is-media-loaded')) return;
        var img = grid.querySelector('img');
        function done() { grid.classList.add('is-media-loaded'); }
        if (!img || img.complete) { done(); return; }
        img.addEventListener('load', done, { once: true });
        img.addEventListener('error', done, { once: true });
      });
    }

    markMedia();
    ready(apply);
    ready(markMedia);
    window.addEventListener('load', function () { apply(); markMedia(); });
    window.addEventListener('resize', apply);
    document.addEventListener('shopify:section:load', function () { apply(); markMedia(); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-rezept"] && !Shopify.designMode) return;
  try {
    
  /* Sauberes Druck-/PDF-Dokument bauen (statt die ganze Seite zu drucken). */
  function rezeptEsc(s) {
    return (s || '').replace(/[&<>]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;' }[c]; });
  }
  function rezeptCollectZutaten(section) {
    var items = [];
    section.querySelectorAll('.rezept__zutaten-list > li').forEach(function (li) {
      var text = li.querySelector('.rezept__zutat-text');
      var line = (text || li).textContent.replace(/\s+/g, ' ').trim();
      if (line) items.push(line);
    });
    return items;
  }
  function rezeptBuildDoc(section, mode) {
    var title = (section.querySelector('.rezept__title') || {}).textContent || 'Rezept';
    title = title.trim();
    var logo = section.getAttribute('data-pdf-logo') || '';
    var shopUrl = section.getAttribute('data-pdf-url') || '';
    var yieldTxt = ((section.querySelector('.rezept__zutaten-yield') || {}).textContent || '').replace(/\s+/g, ' ').trim();
    var zList = rezeptCollectZutaten(section).map(function (z) { return '<li>' + rezeptEsc(z) + '</li>'; }).join('');

    var facts = '', steps = '';
    if (mode === 'full') {
      section.querySelectorAll('.rezept__fact').forEach(function (f) {
        // Portionen-Fact enthält den Wähler (Button-Labels) → überspringen,
        // die „Für X Portionen"-Zeile zeigt die gewählte Menge.
        if (f.querySelector('.rezept__portionen')) return;
        var dt = ((f.querySelector('dt') || {}).textContent || '').replace(/\s+/g, ' ').trim();
        var dd = ((f.querySelector('dd') || {}).textContent || '').replace(/\s+/g, ' ').trim();
        if (dt && dd) facts += '<span><b>' + rezeptEsc(dt) + ':</b> ' + rezeptEsc(dd) + '</span>';
      });
      section.querySelectorAll('.rezept__steps > li').forEach(function (li) {
        var t = ((li.querySelector('.rezept__step-titel') || {}).textContent || '').trim();
        var x = ((li.querySelector('.rezept__step-text') || {}).textContent || '').replace(/\s+/g, ' ').trim();
        steps += '<li>' + (t ? '<b>' + rezeptEsc(t) + '</b>' : '') + (x ? '<br>' + rezeptEsc(x) : '') + '</li>';
      });
    }

    var css = '@page{margin:18mm}*{box-sizing:border-box}body{font-family:Georgia,"Times New Roman",serif;color:#111;margin:0;line-height:1.5}'
      + 'h1{font-size:24pt;margin:0 0 6pt;font-weight:600}.meta{font-size:9pt;color:#666;margin:0 0 14pt}'
      + '.facts{font-size:10pt;color:#333;margin:0 0 16pt;display:flex;gap:20pt;flex-wrap:wrap}'
      + '.cols{display:flex;gap:24pt;align-items:flex-start}.col-z{flex:0 0 38%}.col-s{flex:1}'
      + 'h2{font-family:Arial,Helvetica,sans-serif;font-size:9pt;letter-spacing:.12em;text-transform:uppercase;color:#000;border-bottom:1.5pt solid #a8566a;padding-bottom:3pt;margin:0 0 8pt}'
      + 'ul.z{list-style:none;margin:0;padding:0;font-size:10.5pt}ul.z li{padding:3.5pt 0;border-bottom:.5pt solid #ddd}'
      + 'ol.s{margin:0;padding:0;list-style:none;counter-reset:s;font-size:10.5pt}ol.s li{counter-increment:s;margin:0 0 9pt;padding-left:24pt;position:relative;break-inside:avoid}'
      + 'ol.s li::before{content:counter(s,decimal-leading-zero);position:absolute;left:0;top:0;font-family:Arial,sans-serif;font-weight:700;color:#a8566a}'
      + 'ul.zfull{list-style:none;margin:0;padding:0;font-size:11pt;columns:2;column-gap:28pt}ul.zfull li{padding:4pt 0;break-inside:avoid;border-bottom:.5pt solid #ddd}'
      + '.brand{margin:0 0 16pt}.brand img{height:30pt;width:auto;display:block}'
      + '.brand-txt{font-family:Georgia,"Times New Roman",serif;font-size:19pt;font-weight:600;letter-spacing:.2em}'
      + '.foot{margin-top:24pt;padding-top:8pt;border-top:.5pt solid #ddd;font-family:Arial,Helvetica,sans-serif;font-size:8.5pt;color:#999;letter-spacing:.05em;text-align:center}';

    var brand = '<div class="brand">'
      + (logo ? '<img src="' + rezeptEsc(logo) + '" alt="NUA">' : '<span class="brand-txt">NUA</span>')
      + '</div>';
    var foot = shopUrl ? '<p class="foot">' + rezeptEsc(shopUrl) + '</p>' : '';

    var body;
    if (mode === 'shopping') {
      body = '<h1>' + rezeptEsc(title) + '</h1><p class="meta">Einkaufsliste'
        + (yieldTxt ? ' · ' + rezeptEsc(yieldTxt) : '') + '</p><ul class="zfull">' + zList + '</ul>';
    } else {
      body = '<h1>' + rezeptEsc(title) + '</h1>'
        + (facts ? '<div class="facts">' + facts + '</div>' : '')
        + '<div class="cols"><div class="col-z"><h2>Zutaten</h2>'
        + (yieldTxt ? '<p class="meta">' + rezeptEsc(yieldTxt) + '</p>' : '')
        + '<ul class="z">' + zList + '</ul></div>'
        + '<div class="col-s"><h2>Zubereitung</h2><ol class="s">' + steps + '</ol></div></div>';
    }
    return '<!doctype html><html lang="de"><head><meta charset="utf-8"><title>' + rezeptEsc(title) + '</title><style>' + css + '</style></head><body>' + brand + body + foot + '</body></html>';
  }
  // Wartet, bis die Bilder (Logo) im Zielfenster geladen sind, dann Callback.
  // Fallback-Timeout, falls ein Bild hängt.
  function rezeptWaitImages(win, cb) {
    var imgs = (win.document.images) || [];
    var pending = 0;
    var i;
    for (i = 0; i < imgs.length; i++) { if (!imgs[i].complete) pending++; }
    if (pending === 0) { setTimeout(cb, 50); return; }
    var onDone = function () { if (--pending <= 0) setTimeout(cb, 50); };
    for (i = 0; i < imgs.length; i++) {
      if (!imgs[i].complete) { imgs[i].addEventListener('load', onDone); imgs[i].addEventListener('error', onDone); }
    }
    setTimeout(cb, 1500);
  }
  function rezeptPrint(html) {
    // Mobile/Tablet: iframe-Druck ist dort unzuverlässig (iOS Safari druckt die
    // ganze Seite statt des iframes → „Standard-Druck"). Stattdessen das saubere
    // Dokument in einem neuen Tab öffnen und von dort drucken/teilen.
    var isMobile = window.matchMedia('(max-width: 1024px)').matches
      || /iPad|iPhone|iPod|Android/i.test(navigator.userAgent);
    if (isMobile) {
      var w = window.open('', '_blank');
      if (w) {
        w.document.open();
        w.document.write(html);
        w.document.close();
        rezeptWaitImages(w, function () { try { w.focus(); w.print(); } catch (e) {} });
        return;
      }
      // Popup blockiert → unten auf das iframe-Verfahren zurückfallen.
    }

    var f = document.createElement('iframe');
    f.setAttribute('aria-hidden', 'true');
    // Reale Layoutbreite (~A4 @96dpi), aber off-screen versteckt – sonst drucken
    // manche Browser ein 0×0-iframe leer. Höhe 0 stört den Seitenfluss nicht.
    f.style.cssText = 'position:fixed;left:-9999px;top:0;width:794px;height:0;border:0;';

    var removed = false;
    function cleanup() {
      if (removed) return;
      removed = true;
      f.remove();
    }
    var printed = false;
    function doPrint() {
      if (printed) return;
      printed = true;
      var win = f.contentWindow;
      // Aufräumen, sobald der Druckdialog geschlossen wird (Fallback-Timeout falls afterprint nie feuert).
      try { win.addEventListener('afterprint', cleanup); } catch (e) {}
      try { win.focus(); win.print(); } catch (e) {}
      setTimeout(cleanup, 60000);
    }

    // srcdoc statt document.write: genau EIN load-Event, nachdem der Inhalt
    // geparst ist – kein about:blank-Wettlauf, der vorher auf leerem Dokument
    // druckt. onload vor dem Setzen von srcdoc/append registrieren.
    f.onload = function () { rezeptWaitImages(f.contentWindow, doPrint); };
    f.srcdoc = html;
    document.body.appendChild(f);
  }

  class RezeptPrint extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      var section = this.closest('.rezept');
      var btn = this.querySelector('button');
      if (btn && section) btn.addEventListener('click', function () { rezeptPrint(rezeptBuildDoc(section, 'full')); }, { signal: this.ac.signal });
    }
    disconnectedCallback() { this.ac?.abort(); }
  }
  if (!customElements.get('rezept-print')) customElements.define('rezept-print', RezeptPrint);

  class RezeptShopping extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      var section = this.closest('.rezept');
      var btn = this.querySelector('button');
      if (btn && section) btn.addEventListener('click', function () { rezeptPrint(rezeptBuildDoc(section, 'shopping')); }, { signal: this.ac.signal });
    }
    disconnectedCallback() { this.ac?.abort(); }
  }
  if (!customElements.get('rezept-shopping')) customElements.define('rezept-shopping', RezeptShopping);

  /* Abhakbare Zutaten + Mengen hervorheben + Zähler/Reset. Zustand in localStorage. */
  class RezeptZutaten extends HTMLElement {
    connectedCallback() {
      this.key = 'nua-zutaten:' + (this.dataset.recipeKey || 'rezept');
      this.boxes = Array.from(this.querySelectorAll('.rezept__zutat-check'));
      // Stabilen Schlüssel je Zutat aus dem normalisierten Text merken (überlebt
      // Reihenfolge-/Anzahl-Änderungen im Admin – anders als ein reiner Array-Index).
      this.boxes.forEach((box) => {
        const textEl = box.closest('.rezept__zutat')?.querySelector('.rezept__zutat-text');
        box.dataset.zutatKey = ((textEl || box).textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
      });
      this.countEl = this.querySelector('[data-count]');
      this.totalEl = this.querySelector('[data-total]');
      this.resetBtn = this.querySelector('[data-reset]');
      this.ac = new AbortController();
      const signal = this.ac.signal;

      if (this.dataset.scale === 'true') this.prepareAmounts();
      if (this.totalEl) this.totalEl.textContent = this.boxes.length;
      this.restore();
      this.boxes.forEach((box) => {
        if (box.checked) box.closest('.rezept__zutat')?.classList.add('is-checked');
        box.addEventListener('change', () => {
          box.closest('.rezept__zutat')?.classList.toggle('is-checked', box.checked);
          this.persist();
          this.updateCount();
        }, { signal });
      });
      this.resetBtn?.addEventListener('click', () => this.reset(), { signal });
      this.updateCount();

      // Portionen-Rechner: skaliert die aus dem Freitext geparsten Mengen.
      this.basePortions = parseFloat(this.dataset.basePortions) || 0;
      // Portionen-Buttons stehen oben in den Facts (außerhalb dieses Wrappers) →
      // section-weit suchen statt nur in this.
      var portionRoot = this.closest('.rezept') || this;
      this.portionBtns = Array.from(portionRoot.querySelectorAll('[data-portions]'));
      this.amounts = Array.from(this.querySelectorAll('.rezept__zutat-qty[data-base-amount]'));
      this.yieldEl = this.querySelector('[data-yield]');
      if (this.basePortions > 0 && this.portionBtns.length) {
        this.portionBtns.forEach((b) => {
          b.addEventListener('click', () => this.setPortions(parseFloat(b.dataset.portions)), { signal });
        });
        this.setPortions(this.basePortions);
      }
    }
    disconnectedCallback() { this.ac?.abort(); }

    setPortions(target) {
      if (!target || !this.basePortions) return;
      const factor = target / this.basePortions;
      this.amounts.forEach((el) => {
        const base = parseFloat(el.dataset.baseAmount);
        if (!isNaN(base)) el.textContent = this.fmtQty(base * factor);
      });
      if (this.yieldEl) this.yieldEl.textContent = Number.isInteger(target) ? target : this.fmtQty(target);
      this.portionBtns.forEach((b) => {
        b.setAttribute('aria-pressed', parseFloat(b.dataset.portions) === target ? 'true' : 'false');
      });
    }
    fmtQty(n) {
      if (n == null || isNaN(n)) return '';
      const r = Math.round(n * 4) / 4; // auf ¼ runden
      const whole = Math.floor(r);
      const frac = r - whole;
      const map = { 0.25: '¼', 0.5: '½', 0.75: '¾' };
      let s = '';
      if (whole > 0) s += whole;
      if (frac > 0) s += (whole > 0 ? ' ' : '') + map[frac];
      return s === '' ? '0' : s;
    }

    updateCount() {
      const n = this.boxes.filter((b) => b.checked).length;
      if (this.countEl) this.countEl.textContent = n;
      if (this.resetBtn) this.resetBtn.hidden = n === 0;
    }
    reset() {
      this.boxes.forEach((b) => {
        b.checked = false;
        b.closest('.rezept__zutat')?.classList.remove('is-checked');
      });
      this.persist();
      this.updateCount();
    }

    prepareAmounts() {
      // Führende Menge (Zahl) im Freitext skalierbar machen: nur die Zahl wird in
      // <strong data-base-amount> gewickelt, Einheit + Name bleiben Text.
      const re = /^(\s*)(\d+(?:[.,]\d+)?)/;
      this.querySelectorAll('.rezept__zutat-text').forEach((el) => {
        const t = el.textContent;
        const m = t.match(re);
        if (!m) return;
        const num = parseFloat(m[2].replace(',', '.'));
        if (isNaN(num)) return;
        const rest = t.slice(m[0].length);
        const strong = document.createElement('strong');
        strong.className = 'rezept__zutat-qty';
        strong.dataset.baseAmount = String(num);
        strong.textContent = m[2];
        el.textContent = '';
        if (m[1]) el.appendChild(document.createTextNode(m[1]));
        el.appendChild(strong);
        el.appendChild(document.createTextNode(rest));
      });
    }
    restore() {
      let saved = [];
      try { saved = JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) {}
      if (!Array.isArray(saved)) saved = [];
      this.boxes.forEach((box) => { if (saved.includes(box.dataset.zutatKey)) box.checked = true; });
    }
    persist() {
      const checked = this.boxes.filter((b) => b.checked).map((b) => b.dataset.zutatKey);
      try { localStorage.setItem(this.key, JSON.stringify(checked)); } catch (e) {}
    }
  }
  if (!customElements.get('rezept-zutaten')) customElements.define('rezept-zutaten', RezeptZutaten);

  /* Kochmodus: Schritte abhaken + aktiver Schritt + Fortschritt + Wake Lock. */
  class RezeptCook extends HTMLElement {
    connectedCallback() {
      this.toggle = this.querySelector('[data-cook-toggle]');
      this.label = this.querySelector('[data-cook-label]');
      this.steps = Array.from(this.querySelectorAll('.rezept__step'));
      this.active = false;
      this.wakeLock = null;
      this.ac = new AbortController();
      const signal = this.ac.signal;

      this.doneBtns = Array.from(this.querySelectorAll('[data-step-done]'));
      this.toggle?.addEventListener('click', () => this.setActive(!this.active), { signal });
      this.doneBtns.forEach((btn) => {
        btn.addEventListener('click', () => {
          const li = btn.closest('.rezept__step');
          const done = li.classList.toggle('is-done');
          btn.setAttribute('aria-pressed', done ? 'true' : 'false');
          this.updateProgress();
        }, { signal });
      });
      document.addEventListener('visibilitychange', () => {
        if (this.active && document.visibilityState === 'visible') this.requestLock();
      }, { signal });
    }
    disconnectedCallback() {
      this.ac?.abort();
      this.releaseLock();
    }
    setActive(on) {
      this.active = on;
      this.classList.toggle('is-cooking', on);
      this.toggle?.setAttribute('aria-pressed', on ? 'true' : 'false');
      // Abhaken-Buttons nur im Kochmodus tabbierbar (sonst per CSS unsichtbar, aber fokussierbar).
      this.doneBtns.forEach((btn) => { btn.hidden = !on; });
      this.updateProgress();
      if (on) this.requestLock(); else this.releaseLock();
    }
    updateProgress() {
      // Aktiven (nächsten offenen) Schritt markieren.
      this.steps.forEach((s) => s.classList.remove('is-active'));
      if (this.active) {
        const next = this.steps.find((s) => !s.classList.contains('is-done'));
        if (next) next.classList.add('is-active');
      }
      // Zähler im Button-Label.
      const done = this.steps.filter((s) => s.classList.contains('is-done')).length;
      if (this.label) this.label.textContent = this.active ? 'Kochmodus · ' + done + '/' + this.steps.length : 'Kochmodus';
    }
    async requestLock() {
      if (!('wakeLock' in navigator)) return;
      try { this.wakeLock = await navigator.wakeLock.request('screen'); } catch (e) {}
    }
    releaseLock() {
      try { this.wakeLock?.release(); } catch (e) {}
      this.wakeLock = null;
    }
  }
  if (!customElements.get('rezept-cook')) customElements.define('rezept-cook', RezeptCook);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moments-carousel"] && !Shopify.designMode) return;
  try {
    
  class MomentsCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.cards = Array.from(this.querySelectorAll('[data-moment]'));
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      if (!this.track || !this.cards.length) return;

      // Listener gebündelt trennbar machen (disconnectedCallback).
      this._ac = new AbortController();
      const signal = this._ac.signal;

      this.prev?.addEventListener('click', () => this.step(-1), { signal });
      this.next?.addEventListener('click', () => this.step(1), { signal });

      // Tastaturbedienung des scroll-snap-Tracks (Pfeil links/rechts).
      this.track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); this.step(-1); }
        else if (e.key === 'ArrowRight') { e.preventDefault(); this.step(1); }
      }, { signal });

      this.onScroll = this.onScroll.bind(this);
      this.track.addEventListener('scroll', this.onScroll, { passive: true, signal });
      window.addEventListener('resize', this.onScroll, { signal });
      // Bilder laden asynchron → Track-Breite (Overflow) ändert sich nach dem ersten Frame.
      // Ohne Neu-Messung bliebe der Next-Pfeil fälschlich deaktiviert.
      window.addEventListener('load', this.onScroll, { signal });
      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(() => this.onScroll());
        this._ro.observe(this.track);
      }
      this.cards.forEach((card) => {
        const img = card.querySelector('img');
        if (img && !img.complete) img.addEventListener('load', this.onScroll, { once: true, signal });
      });

      requestAnimationFrame(() => this.update());
    }

    disconnectedCallback() {
      this._ac?.abort();
      this._ro?.disconnect();
      if (this._raf) cancelAnimationFrame(this._raf);
    }

    step(dir) {
      const slide = this.cards[0].closest('li') || this.cards[0];
      const gap = parseFloat(getComputedStyle(this.track).columnGap || '0') || 0;
      const amount = slide.getBoundingClientRect().width + gap;
      const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.track.scrollBy({ left: dir * amount, behavior: reduce ? 'auto' : 'smooth' });
    }

    onScroll() {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(() => this.update());
    }

    update() {
      const box = this.track.getBoundingClientRect();
      const center = box.left + box.width / 2;
      let best = null;
      let bestDist = Infinity;
      for (const card of this.cards) {
        const r = card.getBoundingClientRect();
        const dist = Math.abs(r.left + r.width / 2 - center);
        if (dist < bestDist) { bestDist = dist; best = card; }
      }
      for (const card of this.cards) card.classList.toggle('is-centered', card === best);

      const max = this.track.scrollWidth - this.track.clientWidth - 1;
      if (this.prev) this.prev.disabled = this.track.scrollLeft <= 1;
      if (this.next) this.next.disabled = this.track.scrollLeft >= max;
    }
  }
  if (!customElements.get('moments-carousel')) {
    customElements.define('moments-carousel', MomentsCarousel);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recipe-grid-v2"] && !Shopify.designMode) return;
  try {
    
  class RecipeFilter extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const buttons = this.querySelectorAll('[data-filter]');
      const items = this.querySelectorAll('[data-category]');
      buttons.forEach((btn) => {
        btn.addEventListener(
          'click',
          () => {
            const filter = btn.getAttribute('data-filter');
            buttons.forEach((b) => b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'));
            items.forEach((item) => {
              const match = filter === 'all' || item.getAttribute('data-category') === filter;
              item.hidden = !match;
            });
          },
          { signal: this.controller.signal }
        );
      });
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
    }
  }
  if (!customElements.get('recipe-filter')) {
    customElements.define('recipe-filter', RecipeFilter);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wine-feature"] && !Shopify.designMode) return;
  try {
    
  // Variantenauswahl der Produkt-Bänder. Die Pillen liegen ausserhalb des
  // Formulars; beim Wechsel wird nur das versteckte Feld „id" umgeschrieben –
  // genau das liest product-form.js (FormData bzw. refs.variantId) beim
  // Warenkorb-Klick. Zusaetzlich wird die Preisanzeige des Bandes
  // nachgezogen. Ein Listener am Dokument reicht fuer alle Baender.
  (function () {
    if (window.__nuaWineFeatureVariants) return;
    window.__nuaWineFeatureVariants = true;

    document.addEventListener('change', function (event) {
      var input = event.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.hasAttribute('data-wf-variant') || !input.checked) return;

      var band = input.closest('[data-wf-band]');
      if (!band) return;

      var hidden = band.querySelector('input[name="id"]');
      if (hidden) hidden.value = input.value;

      var amount = band.querySelector('[data-wf-amount]');
      if (amount && input.dataset.wfPrice) amount.textContent = input.dataset.wfPrice;

      var compare = band.querySelector('[data-wf-compare]');
      if (compare) {
        var comparePrice = input.dataset.wfComparePrice || '';
        compare.textContent = comparePrice;
        compare.hidden = comparePrice === '';
        if (amount) amount.classList.toggle('wine-feature__amount--sale', comparePrice !== '');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
